export default __webpack_public_path__ + "static/cyber-lisa-334b2a92ea067cf4b6acef4cfddf4675.mp4";